import * as React from 'react';

import { css, StyleSheet } from 'aphrodite';

import theme from '../theme/index';

interface IProps {
    children: any;
    className?: string;
}

class View extends React.Component<IProps> {
    public render() {
        const { children, className } = this.props;

        return (
            <div className={`${css(styles.content)} ${className}`}>
                {children}
            </div>
        );
    }
}

const styles = StyleSheet.create({
    content: {
        [`@media (max-width: ${theme.breakpoints.large}px)`]: {
            paddingLeft: '2.5vw',
            paddingRight: '2.5vw',
        },
        [`@media (max-width: ${theme.breakpoints.small}px)`]: {
            paddingLeft: '4vw',
            paddingRight: '4vw',
        },
        paddingLeft: '1vw',
        paddingRight: '1vw',
    },
});

export default View;
